import { Sine, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as V from "Data/Version";

export class SplashScreen extends HLF.SplashScreen {
    private readonly _bg: PIXI.Sprite;
    private readonly _callback!: () => void;
    private readonly _versionText!: PIXI.BitmapText;

    public constructor() {
        super();

        this._bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bg.anchor.set(0.5);
        this._bg.interactive = true;
        this.addChild(this._bg);
    }

    public init(pSize: PIXI.Point) {
        super.init(pSize);

        const loadingText = HLF.PixiUtils.makeText(`Splash Screen`, Constants.FONT_GEL_MED_35, 35, 0x555555);
        this.addChild(loadingText);

        this.onResize(pSize);
    }

    public animateIn(pOnComplete: () => void): void {
        TweenMax.to(this, 0.5, {
            alpha: 1,
            ease: Sine.easeInOut,
            onComplete: pOnComplete,
        });
    }

    public animateOut(pOnComplete: () => void): void {
        TweenMax.to(this, 0.5, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: pOnComplete,
        });
    }

    public onLoadComplete(pCallback: () => void): void {
        pCallback();
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this._bg.width = pSize.x;
        this._bg.height = pSize.y;
    }
}
